import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  yourCoverReceiptContainer: {
    margin: '1rem 3rem 3rem 3rem',
    '& h3': {
      marginBottom: '2rem',
    },
    '@media (max-width: 767px)': {
      margin: '0',
    },
  },
  yourCoverReceiptInnerContainer: {
    border: `2px solid ${theme.palette.light[400]}`,
    borderRadius: '4px',
    backgroundColor: theme.palette.common.white,
    padding: '2rem 3rem 2rem 3rem',
    width: '100%',
    '@media (max-width: 767px)': {
      padding: '1.5rem',
    },
  },
  heading: {
    marginBottom: '2rem',
    '@media (max-width: 767px)': {
      marginBottom: '1rem',
      fontSize: '1.125rem',
    },
  },
  yourCoverReceiptDataContainer: {
    display: 'flex',
    width: '100%',
    '& p': {
      marginBottom: '1rem',
      lineHeight: '1.5rem',
    },
    '@media (max-width: 767px)': {
      marginBottom: ' 1.2rem',
      flexDirection: 'column',
      '& span': {
        display: 'flex',
        marginBottom: 0,
      },
      '& p': {
        marginBottom: 0,
      },
      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
  yourCoverReceiptLabelContainer: {
    minWidth: '11rem',
  },
  policyLabel: {
    color: theme.palette.dark[600],
  },
}));
